module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attachments"
  }, [_vm._l((_vm.attachments), function(attachment, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('md-input-container', {
      staticClass: "col-md-6"
    }, [_c('label', [_vm._v("Kategória")]), _vm._v(" "), _c('md-select', {
      model: {
        value: (_vm.attachments[index].type),
        callback: function($$v) {
          _vm.$set(_vm.attachments[index], "type", $$v)
        },
        expression: "attachments[index].type"
      }
    }, _vm._l((_vm.attachmentTypes), function(attachmentType) {
      return _c('md-option', {
        attrs: {
          "value": attachmentType.value
        }
      }, [_vm._v(_vm._s(attachmentType.label))])
    }))], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Név")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (attachment.name),
        callback: function($$v) {
          _vm.$set(attachment, "name", $$v)
        },
        expression: "attachment.name"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Érték")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (attachment.value),
        callback: function($$v) {
          _vm.$set(attachment, "value", $$v)
        },
        expression: "attachment.value"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.newAttachment()
      }
    }
  }, [_vm._v("Kapcsolati adat hozzáadása")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16faa600!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/AttachmentBlock.vue
// module id = 548
// module chunks = 2